/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SystemSettingCategories {
    SystemEmailTemplates = 100,
    VersionControl = 800,
    Technical = 900,
}
